import React, { useState, useEffect, useRef, Fragment } from "react";
import ScrollLock, { TouchScrollable } from "react-scrolllock";
import KapitolLogo from "../../assets/images/kapitol-logo.svg";
import KapitolLogoWhite from "../../assets/images/kapitol-logo-white.svg";
import PhoneHeader from "../../assets/images/phone-header.svg";
import { Box, Container, Flex } from "../../style/Grid";
import { MobileNav } from "../../style/Header/MobileNav";

import { mainNavigation, contact, URLS, kapitolSites } from "../../const/const";
import { HeaderContact, HeaderLogo, HeaderNavigation, HeaderNavigationItem, HeaderWrapper, MobileMenuToggle } from "../../style/Header";
import Link from "../../components/Link";
import { Image } from "../../style/Image";
import { Text } from "../../style/Text";
import isActive from "../../utils/isActive";
import { MobileNavContent } from "../../style/Header/MobileNavContent";
import { MobileNavMemuItem } from "../../style/Header/MobileNavMemuItem";
import { Heading } from "../../style/Heading";
import Icon from "../../style/Icon";
import { Button } from "../../style/Button";
import { DivisionMobile, DivisionMobileItem, DivisionNavItem } from "../../style/DivisionNav";
import { SiteNavLink } from "../../style/Footer";
import { MenuClose, MenuOpen } from "../../assets/Svg";

let lastScrollTop = 0;

const Header = ({ variant, activeNav, noNav, noPhone, activeSite = "kfp" }) => {
  const navBarRef = useRef(null);
  const [mobileMenuOpen, toggleMobileMenu] = useState(false);
  const [isMenuFixed, setMenuFixed] = useState(true);
  const [isMenuTop, setMenuTop] = useState(true);

  useEffect(() => {
    function handleScroll() {
      const delta = 5;
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

      if (mobileMenuOpen) return;

      if (Math.abs(lastScrollTop - scrollTop) <= delta) return;

      setMenuTop(scrollTop < navBarRef.current.offsetHeight);

      if (scrollTop > 0 && scrollTop > lastScrollTop) {
        setMenuFixed(false);
      } else {
        if (scrollTop + window.innerHeight < document.body.clientHeight) {
          setMenuFixed(true);
        }
      }

      lastScrollTop = scrollTop;
    }

    window.addEventListener("scroll", handleScroll);

    return function cleanup() {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  // console.log(toggleMobileMenu, isMenuFixed, isMenuTop);
  return (
    <Fragment>
      <HeaderWrapper
        variant={variant}
        ref={navBarRef}
        role="navigation"
        aria-label="main-navigation"
        isFixed={isMenuFixed}
        isMenuTop={isMenuTop}
        position="fixed"
        top={[isMenuFixed ? "0" : "-105px", null, null, isMenuFixed ? "0" : "-158px"]}
      >
        <Box backgroundColor={"panelPrimary"} width={"100%"} display={["none", null, "block", null]}>
          <Container mx={"auto"}>
            <Flex as="ul" margin="0" padding="0" style={{ listStyle: "none" }}>
              {kapitolSites.map((site, index) => {
                return (
                  <li key={index}>
                    <DivisionNavItem as={Link} target="_blank" href={site.url} active={site.id === activeSite}>
                      {site.label}
                    </DivisionNavItem>
                  </li>
                );
              })}
            </Flex>
          </Container>
        </Box>

        <Container
          pt={[0, null, null, 30]}
          alignItems={["center", null, null, "flex-start"]}
          height={"100%"}
          justifyContent={["space-between", null, null, "flex-start"]}
        >
          <Link href={URLS.home} mr={[3, null, null, null, 4]}>
            <HeaderLogo src={variant === "light" || variant === "grey" ? KapitolLogo : KapitolLogoWhite} />
          </Link>

          {!noNav && (
            <HeaderNavigation>
              {mainNavigation.map((page, index) => (
                <HeaderNavigationItem
                  variant={variant}
                  key={index}
                  active={isActive(typeof location !== "undefined" ? (activeNav ? activeNav : location.pathname) : "/", page.url)}
                >
                  <Link href={page.url} fontSize={[16, null, null, null, 20]} lineHeight={"24px"}>
                    <span>{page.label}</span>
                  </Link>
                </HeaderNavigationItem>
              ))}
            </HeaderNavigation>
          )}

          {!noPhone && (
            <HeaderContact>
              <Link href={`tel:${contact.phoneLink}`}>
                <Image src={PhoneHeader} />
                <span dangerouslySetInnerHTML={{ __html: contact.phone }} />
              </Link>
              <Text as="p" color={variant === "light" || variant === "grey" ? "headlinesSecondary" : "footer.link"}>
                Zavolejte&nbsp;nám&nbsp;Po–Pá&nbsp;8:00–16:00
              </Text>
            </HeaderContact>
          )}

          {noNav && noPhone && (
            <Button as={Link} href={"/"} variant={"outline"} display={["none", "block"]} ml={"auto"}>
              Zpět na KAPITOL.cz
            </Button>
          )}

          {!noNav && (
            <MobileMenuToggle
              align
              onClick={() => {
                toggleMobileMenu(!mobileMenuOpen);
              }}
            >
              <Flex flexDirection="column" alignItems={"center"}>
                <Image src={MenuOpen} />
                <Text as="p" color={variant === "light" || variant === "grey" ? "header.menuIconDark" : "white.100"}>
                  Menu
                </Text>
              </Flex>
            </MobileMenuToggle>
          )}
        </Container>
      </HeaderWrapper>

      <ScrollLock isActive={mobileMenuOpen} />
      {mobileMenuOpen && (
        <MobileNav>
          <TouchScrollable>
            <MobileNavContent>
              <Flex flexDirection="column" alignItems="center">
                <MobileMenuToggle
                  position="fixed"
                  top="16px"
                  right="16px"
                  onClick={() => {
                    toggleMobileMenu(!mobileMenuOpen);
                  }}
                >
                  <Flex flexDirection="column" alignItems="center">
                    <Image src={MenuClose} />
                    <Text as="p" color="headlinesSecondary">
                      Zavřít
                    </Text>
                  </Flex>
                </MobileMenuToggle>

                <Link href={URLS.home} mt={4} mb={4}>
                  <Image src={require("../../../static/image/kapitol-icon.png").default} maxWidth="52px" />
                </Link>

                <DivisionMobile>
                  <Flex as={"ul"}>
                    {kapitolSites.map((site, index) => (
                      <li>
                        <DivisionMobileItem as={Link} href={site.url} key={index} target="_blank" active={site.active ? 1 : 0}>
                          {site.label}
                        </DivisionMobileItem>
                      </li>
                    ))}
                  </Flex>
                </DivisionMobile>

                <ul>
                  {mainNavigation.map((item, index) => (
                    <MobileNavMemuItem
                      active={isActive(typeof location !== "undefined" ? (activeNav ? activeNav : location.pathname) : "/", item.url)}
                      key={index}
                    >
                      <Link href={item.url}>{item.label}</Link>
                    </MobileNavMemuItem>
                  ))}
                </ul>

                <Flex flexDirection="column" alignItems="center">
                  <Heading as="h4" fontSize={3} color="cta" fontWeight="400" mb={2} mt={4}>
                    Potřebujete poradit?
                  </Heading>
                  <Text textAlign="center" color="white.100">
                    Jsme Vám k dispozici
                    <br />
                    po-pá 8:00-16:00
                  </Text>
                  <Link href={`tel:${contact.phoneLink}`} mb={2}>
                    <Image mr={2} src={PhoneHeader} />
                    <Text as="span" color="cta" fontSize="27px" fontWeight="300" dangerouslySetInnerHTML={{ __html: contact.phone }} />
                  </Link>
                  <Text textAlign="center" color="white.100" mb={2}>
                    Nebo nám jednoduše napište
                  </Text>
                  <Button as={Link} href={URLS.contactForm} icon mb={"30px"}>
                    <Icon icon="icon-info" width="24px" variant="button" />
                    <span>Chci poradit</span>
                  </Button>
                </Flex>
              </Flex>
            </MobileNavContent>
          </TouchScrollable>
        </MobileNav>
      )}
    </Fragment>
  );
};

export default Header;
